(() => {
  'use strict';
  const closeMenu = (menu, restoreFocus = false) => {
    if (!menu.open) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary')?.focus();
  };
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-mobile-nav]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) closeMenu(menu);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mobile-nav][open]').forEach((menu) => closeMenu(menu, true));
  });
  document.addEventListener('toggle', (event) => {
    if (!event.target.matches('[data-mobile-nav]')) return;
    const summary = event.target.querySelector('summary');
    if (summary) summary.setAttribute('aria-label', event.target.open ? 'Fermer le menu' : 'Ouvrir le menu');
  }, true);
})();
